import React from "react";

const Article = ({ children, title, date }) => (
  <article className="article font-display text-gray-900 border p-4 min-h-screen">
    <h1 className="article__title text-3xl sm:text-4xl md:text-5xl font-bold mb-3">
      {title}
    </h1>
    {date && (
      <div className="text-neutral-dark text-sm my-3">Published {date}</div>
    )}
    {children}
  </article>
);

export default Article;
